import React from "react";

const Banner = () => {
  return (
    <div
      className="container-fluid p-0 position-relative custom-bg-container"
      style={{
        background:
          'url("https://imgs.search.brave.com/-78NPz2G3V3h4gjAds4989_dU43kJGQj742jX902hxc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9t/YW4tdXNpbmctbGFw/dG9wLW5pZ2h0LXRv/cC12aWV3LXdlYi1i/YW5uZXItd2l0aC1j/b3B5LXNwYWNlXzE2/OTAxNi01MzYwNy5q/cGc_c2VtdD1haXNf/aHlicmlk") center center / cover no-repeat',
        height: "440px",
      }}
    >
      {/* Content */}
      <div
        className="container d-flex flex-column h-100 background-text-home"
        style={{ position: "relative" }}
      >
        {/* Mobile View: Buttons */}
        <div className="d-flex d-lg-none justify-content-between mt-3">
          <button className="btn">
            <img
              src="data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16%207H3.83L9.42%201.41L8%200L0%208L8%2016L9.41%2014.59L3.83%209H16V7Z'%20fill='white'/%3e%3c/svg%3e"
              alt="back"
            />
          </button>
          <button className="btn join-group">Leave Group</button>
        </div>

        {/* Text Content */}
        <div className="mt-auto mb-4 text-center text-lg-start">
          <h1 className="text-white">Computer Engineering</h1>
          <p className="text-white mb-5">142,765 Computer Engineers follow this</p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
